export const SEARCH_MODULE_NAME = 'cus-new-search';
